import { SearchClientManager } from "../../../ls2pac/ClientManagers/SearchClientManager";
import { LS2KIDS_CONSTANTS } from "../../constants";

export class KidsCategorySearchClientManager extends SearchClientManager {
	constructor(options) {
		super(options);
	}
	onBeforeFireSearch(event) {
		if (event.id) {
			this.categoryId = event.id;
		}

		if (!event.fromHistory) {
			this.resetPageCache(true);
		}

		super.onBeforeFireSearch(event);
	}
	getSearchParams(event) {
		return {
			categoryId: this.categoryId,
			startIndex: this.currentPage * this.pageSize,
			hitsPerPage: this.pageSize,
			branchFilters: this.getBranchFilters(),
			targetAudience: LS2KIDS_CONSTANTS.targetAudience
		};
	}
	getSearchCount() { }
}




